import React, { useState, useEffect } from 'react';
import { Sidebar as PrimeSidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';

const drawerWidth = 240;

const Sidebar = ({ open, onClose, currentPage, onPageChange }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 960);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 960);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const menuItems = [
    {
      label: 'Dashboard',
      icon: 'pi pi-home',
      command: () => {
        onPageChange('dashboard');
        if (isMobile) onClose();
      }
    },
    {
      label: 'Logs Viewer',
      icon: 'pi pi-list',
      command: () => {
        onPageChange('logs');
        if (isMobile) onClose();
      }
    },
    {
      label: 'Automation',
      icon: 'pi pi-cog',
      command: () => {
        onPageChange('automation');
        if (isMobile) onClose();
      }
    },
    {
      label: 'Users',
      icon: 'pi pi-users',
      command: () => {
        onPageChange('users');
        if (isMobile) onClose();
      }
    },
    {
      label: 'Statistics',
      icon: 'pi pi-chart-bar',
      command: () => {
        onPageChange('statistics');
        if (isMobile) onClose();
      }
    },
    {
      label: 'Stations',
      icon: 'pi pi-map-marker',
      command: () => {
        onPageChange('stations');
        if (isMobile) onClose();
      }
    },
    {
      label: "Casey's pricing",
      icon: 'pi pi-upload',
      command: () => {
        onPageChange('pricing-import');
        if (isMobile) onClose();
      }
    },
    {
      label: 'Combined fuel prices',
      icon: 'pi pi-file-import',
      command: () => {
        onPageChange('fuel-prices-import');
        if (isMobile) onClose();
      }
    },
    {
      label: 'Master locations',
      icon: 'pi pi-map',
      command: () => {
        onPageChange('master-locations');
        if (isMobile) onClose();
      }
    },
    {
      label: 'Price Overrides',
      icon: 'pi pi-dollar',
      command: () => {
        onPageChange('price-overrides');
        if (isMobile) onClose();
      }
    },
    {
      label: 'App announcement',
      icon: 'pi pi-megaphone',
      command: () => {
        onPageChange('app-announcement');
        if (isMobile) onClose();
      }
    },
    {
      label: 'Settings',
      icon: 'pi pi-wrench',
      command: () => {
        onPageChange('settings');
        if (isMobile) onClose();
      }
    },
    {
      label: 'About',
      icon: 'pi pi-info-circle',
      command: () => {
        onPageChange('about');
        if (isMobile) onClose();
      }
    }
  ];

  const sidebarContent = (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', width: drawerWidth }}>
      {/* Header */}
      <div style={{ padding: '1rem', backgroundColor: 'var(--primary-color)', color: 'white', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <img 
          src="/NSFLogo.png" 
          alt="NSF Logo" 
          style={{ height: '32px', width: 'auto', objectFit: 'contain' }}
          onError={(e) => {
            // Fallback to icon if image fails to load
            e.target.style.display = 'none';
            if (!e.target.nextSibling) {
              const icon = document.createElement('i');
              icon.className = 'pi pi-shield';
              icon.style.fontSize = '1.5rem';
              e.target.parentNode.insertBefore(icon, e.target.nextSibling);
            }
          }}
        />
        <h2 style={{ margin: 0, fontSize: '1.25rem', fontWeight: 'bold' }}>Admin Dashboard</h2>
      </div>

      <hr style={{ margin: 0, border: 'none', borderTop: '1px solid #dee2e6' }} />

      {/* Menu Items */}
      <div style={{ flexGrow: 1, paddingTop: '0.5rem' }}>
        {menuItems.map((item, index) => {
          const isActive = (item.label === 'Dashboard' && currentPage === 'dashboard') ||
                          (item.label === 'Users' && currentPage === 'users') ||
                          (item.label === 'Logs Viewer' && currentPage === 'logs') ||
                          (item.label === 'Automation' && currentPage === 'automation') ||
                          (item.label === 'Statistics' && currentPage === 'statistics') ||
                          (item.label === 'Stations' && currentPage === 'stations') ||
                          (item.label === 'App announcement' && currentPage === 'app-announcement') ||
                          (item.label === "Casey's pricing" && currentPage === 'pricing-import') ||
                          (item.label === 'Combined fuel prices' && currentPage === 'fuel-prices-import') ||
                          (item.label === 'Master locations' && currentPage === 'master-locations') ||
                          (item.label === 'Price Overrides' && currentPage === 'price-overrides') ||
                          (item.label === 'Settings' && currentPage === 'settings') ||
                          (item.label === 'About' && currentPage === 'about');
          return (
            <div
              key={index}
              onClick={item.command}
              style={{
                padding: '0.75rem 1rem',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                backgroundColor: isActive ? 'var(--primary-color)' : 'transparent',
                color: isActive ? 'white' : '#495057',
                transition: 'background-color 0.2s',
              }}
              onMouseEnter={(e) => {
                if (!isActive) e.currentTarget.style.backgroundColor = '#f8f9fa';
              }}
              onMouseLeave={(e) => {
                if (!isActive) e.currentTarget.style.backgroundColor = 'transparent';
              }}
            >
              <i className={item.icon} style={{ fontSize: '1.25rem' }}></i>
              <span style={{ fontWeight: isActive ? '600' : '400' }}>{item.label}</span>
            </div>
          );
        })}
      </div>

      <hr style={{ margin: 0, border: 'none', borderTop: '1px solid #dee2e6' }} />

      {/* Logout */}
      <div style={{ padding: '0.5rem 0' }}>
        <div
          onClick={() => {
            localStorage.removeItem('adminToken');
            window.location.href = '/login';
          }}
          style={{
            padding: '0.75rem 1rem',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            color: '#dc3545',
            transition: 'background-color 0.2s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#f8d7da';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
          }}
        >
          <i className="pi pi-sign-out" style={{ fontSize: '1.25rem' }}></i>
          <span style={{ fontWeight: '500' }}>Logout</span>
        </div>
      </div>

      <hr style={{ margin: 0, border: 'none', borderTop: '1px solid #dee2e6' }} />

      {/* Footer */}
      <div style={{ padding: '1rem' }}>
        <p style={{ margin: 0, fontSize: '0.75rem', color: '#6c757d' }}>NorthStar Fuel</p>
        <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.75rem', color: '#6c757d' }}>Admin Panel v1.0</p>
      </div>
    </div>
  );

  if (isMobile) {
    return (
      <PrimeSidebar visible={open} onHide={onClose} style={{ width: drawerWidth }}>
        {sidebarContent}
      </PrimeSidebar>
    );
  }

  return (
    <div style={{ width: drawerWidth, flexShrink: 0, position: 'fixed', left: 0, top: 0, bottom: 0, backgroundColor: 'white', boxShadow: '2px 0 4px rgba(0,0,0,0.1)', zIndex: 1000 }}>
      {sidebarContent}
    </div>
  );
};

export default Sidebar;
